<template>
	<el-row>
		<el-row :gutter="20">
			<el-col :span="6">
				<el-input placeholder="请输入用户id" v-model="memberId" />
			</el-col>
			<el-col :span="6">
				<el-input placeholder="请输入用户名" v-model="memberName" />
			</el-col>
			<el-col :span="6">
				<el-button @click="demand">筛选</el-button>
				<el-button @click="empty">导出excel</el-button>
			</el-col>
		</el-row>
		<el-row>
			<el-table :data="tableData">
				<el-table-column label="序号" prop='planId' width="50px"></el-table-column>
				<el-table-column label="策略方案" prop="planName"></el-table-column>
				<el-table-column label="用户昵称" prop="memberName"></el-table-column>
				<el-table-column label="用户id" prop="memberId"></el-table-column>
				<el-table-column label="用户等级" prop="levelName"></el-table-column>
				<el-table-column label="深耕品类" prop="categoryName"></el-table-column>
				<el-table-column label="代理人设" prop="personaName"></el-table-column>
				<el-table-column label="期望" prop="wishName"></el-table-column>
				<el-table-column label="服务人群" prop="memberCount"></el-table-column>
				<el-table-column label="渠道代理" prop="agentCount"></el-table-column>
				<!-- <el-table-column label="执行" prop="reason"></el-table-column> -->
				<el-table-column label="生成日期" prop="created"></el-table-column>
				<el-table-column label="操作">
					<template slot-scope="scope">
						<el-button @click="toView(scope.row)" type="text">查看</el-button>
					</template>
				</el-table-column>
			</el-table>
		</el-row>
		<div style="margin: 20px 30%;">
			<el-pagination class="pagination" background layout="total, sizes,prev, pager, next,jumper"
				:page-size="pageSize" :page-sizes="[30,50,100]" :total="total" :current-page.sync="pageNum"
				@size-change="handleSizeChange" @current-change="handleCurrentChange" />
		</div>
	</el-row>
</template>

<script>
	export default {
		data() {
			return {
				memberId: '',
				memberName: '',
				pageNum: 1,
				pageSize: 30,
				total: 0,
				tableData: [],
			}
		},
		methods: {
			//查看
			toView(row) {
				console.log(row);
				this.$router.push({
					path: './strDeta',
					query: {
						planId: row.planId
					}
				})
			},
			//置空
			empty() {
				title: ''
			},
			//查询
			demand() {
				this.getInfo()
			},
			getInfo() {
				this.$http.post('/api/plant/plan/selectPlan', {
					memberName: this.memberName,
					memberId: this.memberId,
					pageNum: this.pageNum,
					pageSize: this.pageSize
				}).then(res => {
					console.log(res.data.data.list);
					this.tableData = res.data.data.list
					this.total = res.data.data.total
				})
			},
			handleSizeChange(val) {
				this.pageNum = 1;
				this.pageSize = val;
				this.getInfo()
			},
			//页数
			handleCurrentChange(val) {
				this.pageNum = val;
				this.getInfo()
			},
		},
		created() {
			this.getInfo()
		}
	}
</script>

<style>
</style>
